import React, { useEffect, useMemo, useState } from "react"
import { useSelector } from "react-redux"
import { Container } from "react-bootstrap"
import { Link } from "react-router-dom"
import SearchInput from "components/SearchInput"
import Loader from "components/Loader"
import { getNotificationSettings } from "requesters/notificationSettingsRequester"
import { roleCheck } from "utils/index"
import { OPERATIONS } from "utils/constants"
import { getCurrentRole, getCurrentUser, getBaseUrl } from "apps/App/reducers"
import _ from "lodash"

export default function NotificationSettingsIndex() {
  const baseUrl = useSelector(getBaseUrl)
  const currentUser = useSelector(getCurrentUser)
  const currentRole = useSelector(getCurrentRole)
  const systemRole = currentUser.attributes.role
  const [settings, setSettings] = useState([])
  const [requesting, setRequesting] = useState(false)
  const [bySearch, setBySearch] = useState("")

  if (!roleCheck(systemRole, currentRole, OPERATIONS) && !["admin", "super_admin"].includes(systemRole)) {
    window.location = "/"
  }

  useEffect(() => {
    async function fetchData() {
      setRequesting(true)
      const { response, error } = await getNotificationSettings(baseUrl)
      if (response) {
        const rows = _.values(response.notificationSetting || {})
        setSettings(_.sortBy(rows, row => row.attributes.name))
      }
      if (error) {
        console.error(error)
      }
      setRequesting(false)
    }

    if (baseUrl) fetchData()
  }, [baseUrl])

  const filteredSettings = useMemo(() => {
    const term = (bySearch || "").toLowerCase().trim()
    if (!term) return settings
    return settings.filter(setting => {
      const { name, description, title, body } = setting.attributes
      return [name, description, title, body].some(value => (value || "").toLowerCase().includes(term))
    })
  }, [settings, bySearch])

  return (
    <Container fluid>
      <div className="d-flex justify-content-between align-items-center header-tabs-container">
        <div className="header-tabs">
          <h1>Notifications</h1>
        </div>
      </div>
      <div className="table-listing-filters">
        <div className="btn-group mr-2">
          <SearchInput value={bySearch} setValue={setBySearch} placeholder="Search by name or title" />
        </div>
      </div>
      {requesting ? <Loader /> : <SettingsTable settings={filteredSettings} />}
    </Container>
  )
}

function recipientSummary(attributes) {
  const groups = (attributes.recipientGroups || []).map(group => group.label)
  const users = (attributes.recipientUsers || []).map(user => user.name)
  const labels = [...groups, ...users]
  return labels.length ? labels.join(", ") : "-"
}

function SettingsTable({ settings }) {
  return (
    <div className="table-responsive">
      <table className="table table-listing table-hover">
        <thead>
          <tr>
            <th>Name</th>
            <th>Title</th>
            <th>Recipients</th>
            <th>Fallback</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {settings.map(setting => {
            const { attributes } = setting
            return (
              <tr key={setting.id}>
                <td>{attributes.name}</td>
                <td>{attributes.title || "-"}</td>
                <td>{recipientSummary(attributes)}</td>
                <td>{attributes.fallbackUser?.name || "-"}</td>
                <td className="text-right">
                  <Link to={`/settings/notification-settings/${setting.id}`}>Detail</Link>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      {settings.length === 0 && <div className="text-center">Table is Empty</div>}
    </div>
  )
}
